<template>
  <v-chip x-small :color="meta.color" text-color="white">
    <v-icon x-small left>{{ meta.icon }}</v-icon>
    {{ meta.label }}
  </v-chip>
</template>

<script>
  import { ReleaseStatusMeta } from '@ReleaseNotes/config/enums';

  const UNKNOWN_STATUS_META = Object.freeze({
    label: 'Unknown',
    color: 'grey',
    icon: 'mdi-help-circle-outline',
  });

  export default {
    name: 'ReleaseStatusChip',
    props: {
      status: {
        type: Number,
        default: null,
      },
    },
    computed: {
      /**
       * Status metadata for the chip. An unrecognised or missing status degrades to a neutral
       * grey "Unknown" chip rather than rendering an empty one.
       * Note: `ReleaseStatusMeta[Archived].color` is the two-token class `grey lighten-1`, which
       * is only safe because it is consumed here by `<v-chip color>`.
       */
      meta() {
        const found = ReleaseStatusMeta[this.status];
        return found || UNKNOWN_STATUS_META;
      },
    },
  };
</script>
